// angular
// 	.module("HeroPRO")
// 	.controller("ProjectHistoryModalController", projectHistoryModalController);

import _ from 'lodash';
import './projectHistoryModal.scss';

/* @ngInject */
export default function projectHistoryModalController(fundingRequestId, $uibModalInstance, ProjectHistoryFactory) {
    const vm = this;

    vm.loaded = false;
    vm.history = [];

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.closeModal = function () {
        const result = false;

        $uibModalInstance.close(result);
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    function init() {
        getProjectHistory();
    }


    function getProjectHistory() {
        const params = {
            FundingRequestId: fundingRequestId,
        };

        ProjectHistoryFactory.getProjectHistory(params).then((response) => {
            buildHistorySet(response.data.Data.ProjectHistoryDetails);
            vm.loaded = true;
        });
    }

    function buildHistorySet(historyCollection) {
        const groupedHistoryItems = _.groupBy(historyCollection, item => item.CreatedDate.substring(5, 7));

        _.each(groupedHistoryItems, (groupedItem, key) => {
            const newRecord = {
                month: Number(key),
                records: [],
            };
            vm.history.push(newRecord);
            _.each(groupedItem, (item) => {
                newRecord.records.push(item);
            });
        });
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/projectHistory/projectHistoryModalController.js